module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門2_2_2.05cdcb99.png";